export const ssr = state => state;
